export default "__VITE_ASSET__CZwLHTJn__"